import { useEffect, useState } from 'react'
import { useSprings, animated, to as interpolate } from '@react-spring/web'
import { useDrag } from '@use-gesture/react'
import _ from 'lodash'
import { useStore } from '../store'
import CA1 from '../../../img/app/CA1.PNG'
import CA2 from '../../../img/app/CA2.PNG'
import CA3 from '../../../img/app/CA3.PNG'
import CA4 from '../../../img/app/CA4.PNG'

import MT1 from '../../../img/app/MT1.PNG'
import MT2 from '../../../img/app/MT2.PNG'
import MT3 from '../../../img/app/MT3.PNG'
import MT4 from '../../../img/app/MT4.PNG'
import MT5 from '../../../img/app/MT5.PNG'
import MT6 from '../../../img/app/MT6.PNG'
import MT7 from '../../../img/app/MT7.PNG'
const cardLocal = [
    [
        'https://bqltest.s3.ap-southeast-1.amazonaws.com/bqlPortfolio/project/revit/revit5.PNG',
        'https://bqltest.s3.ap-southeast-1.amazonaws.com/bqlPortfolio/project/revit/revit4.PNG',
        'https://bqltest.s3.ap-southeast-1.amazonaws.com/bqlPortfolio/project/revit/revit3.PNG',
        'https://bqltest.s3.ap-southeast-1.amazonaws.com/bqlPortfolio/project/revit/revit2.PNG',
        'https://bqltest.s3.ap-southeast-1.amazonaws.com/bqlPortfolio/project/revit/revit0.PNG',
        'https://bqltest.s3.ap-southeast-1.amazonaws.com/bqlPortfolio/project/revit/revit1.PNG',
        'https://bqltest.s3.ap-southeast-1.amazonaws.com/bqlPortfolio/project/revit/revit6.PNG',
        'https://bqltest.s3.ap-southeast-1.amazonaws.com/bqlPortfolio/project/revit/revit7.PNG',
    ],
    [
        'https://bqltest.s3.ap-southeast-1.amazonaws.com/bqlPortfolio/project/navis/navis0.PNG',
        'https://bqltest.s3.ap-southeast-1.amazonaws.com/bqlPortfolio/project/navis/navis1.PNG',
        'https://bqltest.s3.ap-southeast-1.amazonaws.com/bqlPortfolio/project/navis/navis2.png',
        'https://bqltest.s3.ap-southeast-1.amazonaws.com/bqlPortfolio/project/navis/navis3.PNG',
    ],
    [
        'https://bqltest.s3.ap-southeast-1.amazonaws.com/bqlPortfolio/project/tk/tk0.PNG',
        'https://bqltest.s3.ap-southeast-1.amazonaws.com/bqlPortfolio/project/tk/tk1.PNG'
    ],
    [
        'https://bqltest.s3.ap-southeast-1.amazonaws.com/bqlPortfolio/project/idd/Idd6.PNG',
        'https://bqltest.s3.ap-southeast-1.amazonaws.com/bqlPortfolio/project/idd/Idd5.PNG',
        'https://bqltest.s3.ap-southeast-1.amazonaws.com/bqlPortfolio/project/idd/Idd4.PNG',
        'https://bqltest.s3.ap-southeast-1.amazonaws.com/bqlPortfolio/project/idd/Idd3.PNG',
        'https://bqltest.s3.ap-southeast-1.amazonaws.com/bqlPortfolio/project/idd/Idd2.PNG',
        'https://bqltest.s3.ap-southeast-1.amazonaws.com/bqlPortfolio/project/idd/Idd1.PNG',
        'https://bqltest.s3.ap-southeast-1.amazonaws.com/bqlPortfolio/project/idd/Idd0.PNG',
        'https://bqltest.s3.ap-southeast-1.amazonaws.com/bqlPortfolio/project/idd/Idd0.PNG',
    ],
    [
        'https://bqltest.s3.ap-southeast-1.amazonaws.com/bqlPortfolio/project/dc/dc6.PNG',
        'https://bqltest.s3.ap-southeast-1.amazonaws.com/bqlPortfolio/project/dc/dc5.PNG',
        'https://bqltest.s3.ap-southeast-1.amazonaws.com/bqlPortfolio/project/dc/dc4.PNG',
        'https://bqltest.s3.ap-southeast-1.amazonaws.com/bqlPortfolio/project/dc/dc3.PNG',
        'https://bqltest.s3.ap-southeast-1.amazonaws.com/bqlPortfolio/project/dc/dc2.PNG',
        'https://bqltest.s3.ap-southeast-1.amazonaws.com/bqlPortfolio/project/dc/dc1.PNG',
        'https://bqltest.s3.ap-southeast-1.amazonaws.com/bqlPortfolio/project/dc/dc0.PNG',
    ],
    [
        'https://bqltest.s3.ap-southeast-1.amazonaws.com/bqlPortfolio/project/pt/pt6.PNG',
        'https://bqltest.s3.ap-southeast-1.amazonaws.com/bqlPortfolio/project/pt/pt5.PNG',
        'https://bqltest.s3.ap-southeast-1.amazonaws.com/bqlPortfolio/project/pt/pt4.PNG',
        'https://bqltest.s3.ap-southeast-1.amazonaws.com/bqlPortfolio/project/pt/pt3.PNG',
        'https://bqltest.s3.ap-southeast-1.amazonaws.com/bqlPortfolio/project/pt/pt2.PNG',
        'https://bqltest.s3.ap-southeast-1.amazonaws.com/bqlPortfolio/project/pt/pt1.PNG',
        'https://bqltest.s3.ap-southeast-1.amazonaws.com/bqlPortfolio/project/pt/pt0.PNG',
    ],
    [
        CA4,
        CA3,
        CA2,
        CA1
    ],
    [
        MT7,
        MT6,
        MT5,
        MT4,
        MT3,
        MT2,
        MT1,
    ]
]

// These two are just helpers, they curate spring data, values that are later being interpolated into css
const beg = (i) => ({
    x: 0,
    y: -5000,
    scale: 1,
    rot: -10 + Math.random() * 20,
    delay: i * 100,
    transform: i
})
const to = (i) => ({
    x: 0,
    y: i * -4,
    scale: 1,
    rot: -10 + Math.random() * 20,
    delay: i * 100,
    transform: i
})
const from = (_i) => ({ x: 0, rot: 0, scale: 1.5, y: -1000 })
// This is being used down there in the view, it interpolates rotation and scale into a css transform
const trans = (r, s) => {
    return `perspective(1500px) rotateX(30deg) rotateY(${r / 10}deg) rotateZ(${r}deg) scale(${s})`
}

let indexL = -1
function Deck() {
    const { setIsDragging, isDragging, project } = useStore()
    const [gone] = useState(() => new Set()) // The set flags all the cards that are flicked out
    const [cards, setCards] = useState(cardLocal[3])
    const [props, api] = useSprings(cards.length, i => {
        let temp = {
            to: to(i),
            from: from(i),

        }
        return (temp)
    })

    useEffect(() => {
        if (project) {
            if (project.index !== indexL && indexL !== -1) {
                indexL = project.index
                let c = cardLocal[project.index - 1]

                api.start(i => beg(i))
                api.set(c.length, i => {
                    let temp = {
                        to: to(i),
                        from: from(i),
                    }
                    return (temp)
                })
                setTimeout(() => {

                    setCards(c)
                    api.start(i => to(i))
                }, 800);

            } else if (indexL === -1) {
                indexL = project.index
            }
        }
    }, [project?.index])
    // Create a gesture, we're interested in down-state, delta (current-pos - click-pos), direction and velocity
    const bind = useDrag(({ args: [index], active, movement: [mx], direction: [xDir], velocity: [vx] }) => {
        const trigger = vx > 0.2 // If you flick hard enough it should trigger the card to fly out
        if (!active && trigger) gone.add(index) // If button/finger's up and trigger velocity is reached, we flag the card ready to fly out
        setIsDragging(true)
        api.start(i => {
            if (index !== i) return // We're only interested in changing spring-data for the current spring
            const isGone = gone.has(index)
            const x = isGone ? (200 + window.innerWidth) * xDir : active ? mx : 0 // When a card is gone it flys out left or right, otherwise goes back to zero
            const rot = mx / 100 + (isGone ? xDir * 10 * vx : 0) // How much the card tilts, flicking it harder makes it rotate faster
            const scale = active ? 1.1 : 1 // Active cards lift up a bit
            return {
                x,
                rot,
                scale,
                delay: undefined,
                config: { friction: 50, tension: active ? 800 : isGone ? 200 : 500 },
                onRest: () => {
                    setIsDragging(false)
                }
            }

        })
        if (!active && gone.size === cards.length)
            setTimeout(() => {
                gone.clear()
                api.start(i => to(i))
            }, 600)
    })

    // Now we're just mapping the animated values to our view, that's it. Btw, this component only renders once. :-)
    return (
        <>
            {props.map(({ x, y, rot, scale, transform }, i) =>
                <animated.div className={'deck'} key={i} style={{ x: x, y: y }}>
                    {/* This is the card itself, we're binding our gesture to it (and inject its index so we know which is which) */}
                    <animated.div
                        {...bind(i)}
                        style={{
                            transform: interpolate([rot, scale], trans),
                            backgroundImage: `url(${cards[i]})`,
                        }}
                    />
                </animated.div>
            )}
        </>
    )
}

export default function AppDeck() {
    return (
        <animated.div className={`flex fill center container`}>
            <Deck />
        </animated.div>
    )
}

